import type { ReactNode } from 'react';

export const symbol_text_select_move_down: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M160-780q-13 0-21.5-8.5T130-810q0-13 8.5-21.5T160-840h640q13 0 21.5 8.5T830-810q0 13-8.5 21.5T800-780H160Zm299 465L355-419q-9-9-9-21t9-21q9-9 21-8.5t21 8.5l53 52v-231q0-13 8.5-21.5T480-670q13 0 21.5 8.5T510-640v231l53-52q9-8 21-8.5t21 8.5q9 9 9 21t-9 21L501-315q-9 9-21 9t-21-9ZM160-120q-13 0-21.5-8.5T130-150q0-13 8.5-21.5T160-180h640q13 0 21.5 8.5T830-150q0 13-8.5 21.5T800-120H160Z"
		/>
	</svg>
);
